import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import * as ApexCharts from 'apexcharts';
import { CoeApprovalComponent } from '../coe-approval/coe-approval.component';
import { CoeRejectComponent } from '../coe-reject/coe-reject.component';

@Component({
  selector: 'app-application-dashboard',
  templateUrl: './application-dashboard.component.html',
  styleUrls: ['./application-dashboard.component.css'],
})
export class ApplicationDashboardComponent implements OnInit {
  // Define the API endpoints for fetching dashboard data and calculating scores
  // These endpoints are used to interact with the backend services.
  panelOpenState = false;
  private getApi = environment.url + 'coe/dashboard?id=';
  private scoreApi = environment.url + environment.calculateScore;
  private ApprovalApi = environment.url + environment.coeapproval;
  private HistoryApi = environment.url + 'coe/history?id=';
  dialogRef: any;
  // Constructor to inject necessary services
  // These services are used for API calls, notifications, and value management.
  constructor(
    private getdata: ValueService,
    private makeapi: ApiService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {}
  NotImplementColor = '#56c2e6';
  incubaterName;
  // This function is called when the component is initialized
  // It fetches the dashboard data and initializes the chart if scoring is enabled.
  ngOnInit(): void {
    this.incubaterName = sessionStorage.getItem('adminIncubName');
    this.getValue();
  }
  // This function fetches the dashboard data from the API
  // and updates the dashboardData property.
  dashboardData: any = {};
  role = sessionStorage.getItem('role');
  incubName = sessionStorage.getItem('incubName');
  applicationNo;
  getValue() {
    this.dashboardData = {};
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.dashboardData = data;
        this.applicationNo = data.applicationNo;
        sessionStorage.setItem('applicationNo', data.applicationNo);
        sessionStorage.setItem('CoeStatus', data.status);
        localStorage.setItem('applicationId', this.dashboardData.applicationId);
        let applicationId = sessionStorage.getItem('applicationId');
        if (this.role == 'CoE' && applicationId == null) {
          window.location.reload();
        }
        sessionStorage.setItem('applicationId', data.applicationId);
      });
  }
  // This function is called when the user clicks the "Generate Score" button.
  // It triggers the score generation process by calling the API.
  timeout: any;
  scoreGenerate() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.scoreApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.getValue();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  // This function creates a radial bar chart using ApexCharts.
  // It takes a value and a string to display in the chart.
  grap(val, str) {
    let num: number = +val;
    let options = {
      series: [num],
      chart: {
        height: 350,
        type: 'radialBar',
        toolbar: {
          show: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: '70%',
            background: '#fff',
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: 'front',
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: '#fff',
            strokeWidth: '67%',
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          dataLabels: {
            show: true,
            name: {
              offsetY: -10,
              show: false,
              color: '#888',
              fontSize: '17px',
            },
            value: {
              formatter: function (val) {
                return str;
              },
              color: '#111',
              fontSize: '36px',
              show: true,
            },
          },
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          shadeIntensity: 0.5,
          gradientToColors: ['#ABE5A1'],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: 'round',
      },
      labels: [],
    };
    let chart = new ApexCharts(document.querySelector('#chart'), options);
    chart.render();
  }
  // This function is called when the user clicks the "Approval" button.
  // It sends an approval request to the API.
  preIncubatorId = sessionStorage.getItem('userId');
  approval() {
    let req = {
      userId: this.preIncubatorId,
      status: 2,
    };
    this.makeapi.method(this.ApprovalApi, req, 'post').subscribe((data) => {
      this.getdata.amizhthLoader('hide');
      if (data.responseStatus == 'Success') {
        this.notify.notifysuccess(data.responseMessage);
        this.getValue();
      }
    });
  }
  // This function opens a dialog for clarification.
  // It allows the user to provide additional information or clarification.
  Clarification(val) {
    const dialogRef = this.dialog.open(CoeRejectComponent, {
      width: '390px',
      hasBackdrop: false,
      data: { _id: val },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getdata.isVisibleSource.next(true);
      this.getValue();
    });
  }
  // This function opens a modal to view the history of an application.
  // It fetches the history data from the API and displays it in the modal.
  name;
  animal;
  History(val) {
    document.getElementById('coeModal').style.display = 'block';
    this.HistoryModal(val);
  }
  // This function closes the modal when the user clicks outside of it.
  // It hides the modal and resets the history data.
  closeModal(): void {
    document.getElementById('coeModal').style.display = 'none'; // Hide the modal
  }
  // This function opens a dialog for verification.
  // It allows the user to verify the application details.
  Verfication(val) {
    const dialogRef = this.dialog.open(CoeApprovalComponent, {
      width: '390px',
      data: { _id: val },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getdata.isVisibleSource.next(true);
      window.location.reload();
    });
  }
  // This function fetches the history of an application from the API.
  // It updates the historyData property with the fetched data.
  historyData;
  noData = false;
  HistoryModal(val) {
    return this.makeapi
      .method(this.HistoryApi + val, '', 'get')
      .subscribe((data) => {
        if (data.coeAppHistory) {
          this.noData = false;
          this.historyData = data.coeAppHistory;
        } else {
          this.noData = true;
        }
      });
  }
  // This function sets the application as resolved.
  // It sends a request to the API to update the application status.
  setReSolved() {
    this.getdata.amizhthLoader('show');
    let req = {
      id: sessionStorage.getItem('applicationId'),
      status: 1,
    };
    this.makeapi.method(this.ApprovalApi, req, 'post').subscribe((data) => {
      this.getdata.amizhthLoader('hide');
      if (data.responseStatus == 'Success') {
        this.closeModal();
        window.location.reload();
      }
    });
  }
  // This function closes the dialog when the user clicks the cancel button.
  // It simply closes the dialog without performing any action.
  cancelReason() {
    this.dialogRef.close();
  }
}
